import { useAppContext } from "components/AppContext"
import { Page } from "@shopify/polaris"
import AnalyzeTemplate from "views/templates/AnalyzeTemplate"
import ObjectiveNavigationTemplate from "views/templates/ObjectiveNavigationTemplate"
import { PILLAR_ENVIRONMENTAL } from "utils/constants/pillars"
import { useAnalyticsTabs } from "components/AnalyticsTabs"
import usePillars from "views/organisms/pillars/usePillars"
import Loading from "components/widgets/Loading"
import withAuthRequired from "components/auth/withAuthRequired"
import Objective13AnalyticsOrganism from "views/organisms/analytics/Objective13AnalyticsOrganism"
import AccessModal from "components/AccessModal"
import React, { useEffect } from "react"
import { useParams, Redirect } from "react-router-dom"

export const explore_URL = "/explore/environmental/13"

const ExplorePage = () => {
  const {
    currentPeriod,
    parentOrganization,
    envScore,
    isEnvScoreLoading,
    isCurrentNodeLoading,
    isParentOrganizationLoading,
    subscription,
  } = useAppContext()

  const { themeId } = useParams()

  const hasAccess = subscription?.features?.explore

  const pillars = usePillars({
    pageName: explore_URL,
  })

  const objectives = [
    {
      objectiveId: 13,
      selected: true,
      url: "/explore/environmental/13/workplace",
    },
  ]

  const { tabs, redirectIfNoAvailableTab } = useAnalyticsTabs(envScore)

  const hasExploreWebsites =
    envScore?.website_analyse?.audit_websites?.length > 0

  const hasWebsiteExploreFeature = subscription?.features?.website_audit_details

  // No Explore access but website explore is available: send the user to
  // /explore/websites instead of the Explore paywall. Guarded by
  // `hasExploreWebsites` so we don't bounce against ExploreWebsitesPage, which
  // redirects back to /explore when there is no audit data.
  const shouldRedirectToExploreWebsites =
    !!subscription &&
    !hasAccess &&
    hasWebsiteExploreFeature &&
    hasExploreWebsites

  useEffect(() => {
    // Wait until the subscription is known, and skip entirely when we're about
    // to redirect to the Websites sub-page: otherwise this effect pushes the
    // user to the first available (paywalled) theme tab and overrides that
    // redirect, leaving them stuck on e.g. /explore/environmental/13/infrastructure.
    if (!subscription || shouldRedirectToExploreWebsites) return
    redirectIfNoAvailableTab(isEnvScoreLoading, isCurrentNodeLoading)
  }, [
    themeId,
    isEnvScoreLoading,
    isCurrentNodeLoading,
    envScore,
    tabs,
    subscription,
    shouldRedirectToExploreWebsites,
  ])

  if (
    isEnvScoreLoading ||
    isCurrentNodeLoading ||
    isParentOrganizationLoading
  ) {
    return <Loading />
  }

  if (shouldRedirectToExploreWebsites) {
    return <Redirect to="/explore/websites" />
  }

  return (
    <ObjectiveNavigationTemplate>
      <Page fullWidth>
        <AnalyzeTemplate
          parentOrganization={parentOrganization}
          themeType={PILLAR_ENVIRONMENTAL}
          objectives={objectives}
          pillars={pillars}
          tabs={tabs}
          periodName={currentPeriod?.name}
        >
          <Objective13AnalyticsOrganism>
            <AccessModal open={!hasAccess} />
          </Objective13AnalyticsOrganism>
        </AnalyzeTemplate>
      </Page>
    </ObjectiveNavigationTemplate>
  )
}

export default withAuthRequired(ExplorePage)
